import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import EmployeeBilingualTable from "./view/EmployeeBilingualTable";

interface Props {}
export const EmployeeBilingual: React.FC<Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_employeebilingual_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) && <EmployeeBilingualTable />}
    </>
  );
};
export default EmployeeBilingual;
